import React from 'react';
import { PortfolioGrid } from 'ui';

const PortfolioGridPage = (): JSX.Element => {
  return <PortfolioGrid />;
};

export default PortfolioGridPage;
